import { ServicoAll } from "@/axios/servico-all";
import {ServicoHttp} from "@/axios/servico-http";

export async function getServerTime() {
  const service = new ServicoAll('/api/current-time',new ServicoHttp(this))
  const response = await service.get();
  return response;
}
